export const TimeEnum = {
	STRAIGHT: 16,
	EIGHTH: 4,
	TRIPLETS: 8,
	MIXED: 22,
}

export default TimeEnum
